import { searchOpcoBillings } from '@webapps/business';
import { useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { Grid } from '@material-ui/core';
import BillingCard from './BillingCard';

const BillingList = ({ opcoRecord }) => {
  const { cx, global } = useStyles(styles);

    const { idUser } = useAuth();

    const { data: { content: billings = [] } = {}, refetch } = useQuery(searchOpcoBillings, {
      key: ['opcoBillings'],
      variables: { 
        id: idUser,
        opcoRecordsId: opcoRecord?.id,
        size: 1000, 
        page: 0,
      },
      keepPreviousData: true
    });

  return (
    <div className={global.recordSection}>
      <div className={cx(global.title, global.blueBar)}>Facture générées</div>
      <Grid container spacing={2}>
        {billings?.length > 0 ? billings?.map((billing) => (
          <Grid key={billing.id} item xs={12} sm={6} xl={4} >
            <BillingCard info={billing} refetch={refetch} />
          </Grid>
        )) : (
          <div>
            Aucune factures
          </div>
        )}
      </Grid>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({

});

export default BillingList;